import { useField, useFormikContext } from "formik";
import React, { useRef } from "react";
import BaseAvailabilityCheckbox from "./BaseAvailabilityCheckbox";

function isOverridden(defaultAvailability, field) {
  if (defaultAvailability === undefined) return false;

  return field.value !== defaultAvailability;
}

export default function AvailabilityCheckbox({ field: name, onChange, defaultAvailability, ...props }) {
  const { setFieldValue } = useFormikContext();
  const [field, , helpers] = useField(name);
  const checkboxInput = useRef(null);
  const overridden = isOverridden(defaultAvailability, field);

  const handleChange = () => {
    const { checked, disabled } = checkboxInput.current;

    if (!disabled) {
      if (onChange) {
        onChange({ checked: !checked, setFieldValue });
      }
      helpers.setValue(!checked);
    }
  };
  const labelId = `checkbox-${field}`;

  return (
    <BaseAvailabilityCheckbox overridden={overridden}>
      <input
        checked={field.value}
        id={labelId}
        onChange={handleChange}
        ref={checkboxInput}
        type="checkbox"
        {...props}
      />
      <label
        aria-label="Availability"
        htmlFor={labelId}
        onClick={() => {
          handleChange(field);
        }}
        role="presentation"
      />
    </BaseAvailabilityCheckbox>
  );
}
